// MODE (not import.meta.env.DEV) so the dev-only API proxy is selected solely
// for the local dev server — unit tests run in Vite mode 'test' and keep the
// direct-API path, matching the previous process.env.NODE_ENV behaviour.
export const isDev = import.meta.env.MODE === 'development'
const useProxyCapturiDevProxy =
  import.meta.env.VITE_USE_CAPTURI_DEV_PROXY === 'true' || isDev

export const API_PREFIX = useProxyCapturiDevProxy
  ? '/api'
  : 'https://api.capturi.ai'
